<div class="page-wrapper">
    <div class="flex-btw" style="align-items: flex-start;">
        <div [ngClass]="{'button': true, 'open': display == false, 'close': display == true}">
            <button mat-icon-button color="primary" (click)="display = !display">
                <mat-icon>settings</mat-icon>
            </button>
        </div>

        <div [ngClass]="{'left-menu': true, 'open': display == true }">
            <div class="title">Settings</div>

            <div class="menu-section" *ngFor="let item of settingsList" 
            [routerLink]="item.route" [routerLinkActiveOptions] = "{exact: true}" routerLinkActive="activeLink" (click)="display = false; $event.stopPropagation()">
                <div class="menu-icon">
                    <mat-icon fontSet="material-icons-outlined">{{item.icon}}</mat-icon>
                </div>
                &nbsp;
                &nbsp;
                <div class="menu-context" >
                    <div class="menu-title">{{item.name}}</div>
                    <div class="menu-description">{{item.description}}</div>
                </div>
            </div>
        </div>

        <div class="right-menu" (click)="display = false; $event.stopPropagation()">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
